import React, { useState, useEffect, useCallback } from 'react';
import ExportLabel from '../../../components/common/ExportLabel/Export';
import PageHeader from '../../../components/common/PageHeader/PageHeader';
import ArchiveSelectedItem from '../../../components/common/ArchiveSelectedItemLabel/ArchiveSelectedItems';
import './UserFeedbacks.css';
import SimpleSearchBox from '../../../components/common/Search/SimpleSearch';
import {
  fetchFeedbackStats,
  fetchFeedbacks,
} from '../../../services/Feedbacks/Feedback'; 

/* ── Inline SVG icons (swap with your icon lib if preferred) ── */
const StarIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M11.5251 2.29489C11.5689 2.20635 11.6366 2.13183 11.7205 2.07972C11.8045 2.02761 11.9013 2 12.0001 2C12.0989 2 12.1957 2.02761 12.2796 2.07972C12.3636 2.13183 12.4313 2.20635 12.4751 2.29489L14.7851 6.97389C14.9373 7.28186 15.1619 7.5483 15.4397 7.75035C15.7175 7.95239 16.0402 8.08401 16.3801 8.13389L21.5461 8.88989C21.644 8.90408 21.7359 8.94537 21.8116 9.00909C21.8872 9.07282 21.9435 9.15644 21.9741 9.2505C22.0047 9.34456 22.0084 9.4453 21.9847 9.54133C21.961 9.63736 21.9109 9.72485 21.8401 9.79389L18.1041 13.4319C17.8577 13.672 17.6734 13.9684 17.5669 14.2955C17.4605 14.6227 17.4352 14.9708 17.4931 15.3099L18.3751 20.4499C18.3924 20.5477 18.3818 20.6485 18.3446 20.7406C18.3074 20.8327 18.245 20.9125 18.1646 20.9709C18.0842 21.0293 17.9891 21.0639 17.89 21.0708C17.7908 21.0777 17.6918 21.0566 17.6041 21.0099L12.9861 18.5819C12.6818 18.4221 12.3433 18.3386 11.9996 18.3386C11.6559 18.3386 11.3174 18.4221 11.0131 18.5819L6.39609 21.0099C6.30842 21.0563 6.20949 21.0772 6.11054 21.0701C6.0116 21.0631 5.91661 21.0285 5.83639 20.9701C5.75616 20.9118 5.69392 20.8321 5.65675 20.7401C5.61957 20.6482 5.60895 20.5476 5.62609 20.4499L6.50709 15.3109C6.56529 14.9716 6.54007 14.6233 6.43363 14.2959C6.32718 13.9686 6.1427 13.672 5.89609 13.4319L2.16009 9.79489C2.08868 9.72593 2.03808 9.63829 2.01405 9.54197C1.99002 9.44565 1.99353 9.34451 2.02417 9.25008C2.05481 9.15566 2.11136 9.07174 2.18737 9.00788C2.26338 8.94402 2.35579 8.90279 2.45409 8.88889L7.61909 8.13389C7.95935 8.08439 8.28248 7.95295 8.56067 7.75088C8.83887 7.54881 9.06379 7.28216 9.21609 6.97389L11.5251 2.29489Z" stroke="#D08700" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);
const ThumbUpIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M7 10V22" stroke="#00A63E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15 5.88L14 10H19.83C20.1405 10 20.4467 10.0723 20.7244 10.2111C21.0021 10.35 21.2437 10.5516 21.43 10.8C21.6163 11.0484 21.7422 11.3367 21.7977 11.6422C21.8533 11.9477 21.8369 12.2619 21.75 12.56L19.42 20.56C19.2988 20.9754 19.0462 21.3404 18.7 21.6C18.3538 21.8596 17.9327 22 17.5 22H4C3.46957 22 2.96086 21.7893 2.58579 21.4142C2.21071 21.0391 2 20.5304 2 20V12C2 11.4696 2.21071 10.9609 2.58579 10.5858C2.96086 10.2107 3.46957 10 4 10H6.76C7.13208 9.9998 7.49674 9.89581 7.81296 9.69972C8.12917 9.50363 8.38442 9.22321 8.55 8.89L12 2C12.4716 2.00584 12.9357 2.11817 13.3578 2.3286C13.7799 2.53902 14.1489 2.84211 14.4374 3.2152C14.7259 3.5883 14.9263 4.02176 15.0237 4.4832C15.1212 4.94464 15.113 5.42213 15 5.88Z" stroke="#00A63E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);
const NeutralIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#D08700" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 15H16" stroke="#D08700" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9 9H9.01" stroke="#D08700" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M15 9H15.01" stroke="#D08700" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);
const ThumbDownIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M17 14V2" stroke="#E7000B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M9.00004 18.12L10 14H4.17004C3.85955 14 3.55333 13.9277 3.27562 13.7889C2.99791 13.65 2.75634 13.4484 2.57004 13.2C2.38375 12.9516 2.25785 12.6633 2.2023 12.3578C2.14676 12.0523 2.16311 11.7381 2.25004 11.44L4.58004 3.44C4.70121 3.02457 4.95385 2.65964 5.30004 2.4C5.64624 2.14036 6.0673 2 6.50004 2H20C20.5305 2 21.0392 2.21071 21.4143 2.58579C21.7893 2.96086 22 3.46957 22 4V12C22 12.5304 21.7893 13.0391 21.4143 13.4142C21.0392 13.7893 20.5305 14 20 14H17.24C16.868 14.0002 16.5033 14.1042 16.1871 14.3003C15.8709 14.4964 15.6156 14.7768 15.45 15.11L12 22C11.5285 21.9942 11.0643 21.8818 10.6422 21.6714C10.2202 21.461 9.85112 21.1579 9.56264 20.7848C9.27416 20.4117 9.07373 19.9782 8.97631 19.5168C8.87889 19.0554 8.887 18.5779 9.00004 18.12Z" stroke="#E7000B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);
const ChatIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M21 15C21 15.5304 20.7893 16.0391 20.4142 16.4142C20.0391 16.7893 19.5304 17 19 17H7L3 21V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V15Z" stroke="#155DFC" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);
const ChevronDownIcon = () => (
  <svg width="12" height="12" fill="currentColor" viewBox="0 0 24 24">
    <path d="M7 10l5 5 5-5z" />
  </svg>
);
const DotsIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="#535353" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="#535353" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="#535353" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

/* ── Constants ── */
const RATING_LABEL_TO_INT = {
  'All Ratings': '',
  'Very Poor': 1,
  'Poor': 2,
  'Okay': 3,
  'Good': 4,
  'Excellent': 5,
};

const RATING_DOT_COLOR = {
  'Very Poor': '#FF0004',
  'Poor':      '#B40003',
  'Okay':      '#CCD300',
  'Good':      '#6AF3C5',
  'Excellent': '#00E231',
};

const RATING_CHART_COLOR = {
  1: '#FF0004',
  2: '#B40003',
  3: '#CCD300',
  4: '#6AF3C5',
  5: '#00E231',
};

const DATE_RANGE_TO_DAYS = {
  'Last 30 Days': '30',
  'Last 7 Days':  '7',
  'Last 90 Days': '90',
};

const issueBadgeClass = (tag) => {
  const map = { Performance: 'performance', Bugs: 'bugs', Navigation: 'navigation', 'UI/Design': 'uidesign', Features: 'features' };
  return map[tag] || 'default';
};

const statusClass = (s) => ({ solved: 'solved', unresolved: 'unsolved' }[s] || 'saved');

/* ── Component ── */
const UserFeedbacks = () => {
  // ── filter state ──────────────────────────────────────────────────────────
  const [ratingFilter, setRating]   = useState('All Ratings');
  const [issueFilter,  setIssue]    = useState('All Issues');
  const [dateFilter,   setDate]     = useState('Last 30 Days');
  const [searchQuery,  setSearch]   = useState('');
  const [currentPage,  setPage]     = useState(1);
  const [selectedItems, setSelected] = useState([]);

  // ── API state ─────────────────────────────────────────────────────────────
  const [stats,       setStats]      = useState(null);
  const [feedbacks,   setFeedbacks]  = useState([]);
  const [totalCount,  setTotalCount] = useState(0);
  const [pageSize]                   = useState(10);
  const [statsLoading,  setStatsLoading]  = useState(true);
  const [tableLoading,  setTableLoading]  = useState(true);
  const [issues,        setIssues]        = useState([]);  // for issue dropdown

  // ── Fetch stats (runs once, not affected by table filters) ────────────────
  useEffect(() => {
    setStatsLoading(true);

    fetchFeedbackStats()
      .then(data => {
        setStats(data);
        setStatsLoading(false);
      })
      .catch(() => setStatsLoading(false));
  }, []);

  // ── Fetch issue list for the dropdown ─────────────────────────────────────
  useEffect(() => {
    fetch('/feedback/issues/', { credentials: 'include' })
      .then(r => r.json())
      .then(data => setIssues(data))
      .catch(() => {});
  }, []);

  // ── Fetch feedback list (re-runs on any filter/page change) ───────────────
  const fetchFeedbackList = useCallback(() => {
    setTableLoading(true);

    const ratingInt = RATING_LABEL_TO_INT[ratingFilter];
    const foundIssue = issues.find(i => i.name === issueFilter);

    fetchFeedbacks({
      rating:     ratingInt || undefined,
      issue_id:   foundIssue?.id,
      date_range: DATE_RANGE_TO_DAYS[dateFilter] || '30',
      search:     searchQuery || undefined,
      page:       currentPage,
      page_size:  pageSize,
    })
      .then(data => {
        setFeedbacks(data.results || []);
        setTotalCount(data.count || 0);
        setTableLoading(false);
      })
      .catch(() => setTableLoading(false));

  }, [ratingFilter, issueFilter, dateFilter, searchQuery, currentPage, pageSize, issues]);
  useEffect(() => {
    if (issues.length > 0 || issueFilter === 'All Issues') {
      fetchFeedbackList();
    }
  }, [fetchFeedbackList, issues]);

  // Reset to page 1 whenever a filter changes
  useEffect(() => { setPage(1); }, [ratingFilter, issueFilter, dateFilter, searchQuery]);

  // ── Derived pagination info ───────────────────────────────────────────────
  const totalPages  = Math.ceil(totalCount / pageSize);
  const showingFrom = totalCount === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const showingTo   = Math.min(currentPage * pageSize, totalCount);

  // ── Dropdown definitions ──────────────────────────────────────────────────
  const issueOptions = ['All Issues', ...issues.map(i => i.name)];
  const dropdowns = [
    { value: ratingFilter, options: ['All Ratings', 'Very Poor', 'Poor', 'Okay', 'Good', 'Excellent'], onChange: (v) => setRating(v) },
    { value: issueFilter,  options: issueOptions,                                                       onChange: (v) => setIssue(v)  },
    { value: dateFilter,   options: ['Last 30 Days', 'Last 7 Days', 'Last 90 Days'],                   onChange: (v) => setDate(v)   },
  ];

  // ── Stat cards (built from API data) ─────────────────────────────────────
  const statCards = stats ? [
    {
      label: 'Average Rating',
      value: `${stats.average_rating} / 5`,
      sub:   `${stats.total_count} responses`,
      icon:  <StarIcon />,
    },
    {
      label: 'Positive Feedback',
      value: `${stats.positive_percent}%`,
      sub:   `${stats.positive_count} responses`,
      icon:  <ThumbUpIcon />,
    },
    {
      label: 'Neutral Feedback',
      value: `${stats.neutral_percent}%`,
      sub:   `${stats.neutral_count} responses`,
      icon:  <NeutralIcon />,
    },
    {
      label: 'Negative Feedback',
      value: `${stats.negative_percent}%`,
      sub:   `${stats.negative_count} responses`,
      icon:  <ThumbDownIcon />,
    },
    {
      label: 'Total Feedback',
      value: String(stats.total_last_30_days),
      sub:   'last 30 days',
      icon:  <ChatIcon />,
    },
  ] : [];

  // ── Max issue count (for bar width scaling, same logic as static version) ─
  const maxIssueCount = stats?.top_issues?.[0]?.count || 1;

  return (
    <div className="whole-container">

      {/* Top heading */}
      <div className="top-heading">
        <PageHeader pageName="Engagement /" nestedpageName="User Feedback" linkTo="" />
        <div className="export-container">
          <ArchiveSelectedItem selectedItems={selectedItems} />
          <ExportLabel />
        </div>
      </div>

      <div className="pagename-container">
        <div className="page-name">
          <h1 className="common-text fts-22 ftw-6 blue">User Feedbacks</h1>
        </div>
      </div>

      <div className="uf-inner table-container">

        {/* ── Stat cards ── */}
        <div className="uf-stats-row">
          {statsLoading
            ? <p className="uf-loading-text">Loading stats…</p>
            : statCards.map(card => (
              <div className="uf-card" key={card.label}>
                <div className="uf-card-inner">
                  <div>
                    <p className="uf-card-label">{card.label}</p>
                    <p className="uf-card-value">{card.value}</p>
                    <p className="uf-card-sub">{card.sub}</p>
                  </div>
                  <div className="uf-icon-box"><span className="uf-icon">{card.icon}</span></div>
                </div>
              </div>
            ))
          }
        </div>

        {/* ── Charts ── */}
        {!statsLoading && stats && (
          <div className="uf-charts-row">

            {/* Rating Distribution */}
            <div className="uf-card">
              <p className="uf-chart-title">Rating Distribution</p>
              <hr className="uf-chart-hr" />
              {stats.rating_distribution.map(r => (
                <div className="uf-bar-row" key={r.label}>
                  <span className="uf-dot" style={{ background: RATING_CHART_COLOR[r.rating] }} />
                  <span className="uf-bar-label">{r.label}</span>
                  <div className="uf-bar-track">
                    <div className="uf-bar-fill" style={{ width: `${r.percent}%`, background: RATING_CHART_COLOR[r.rating] }} />
                  </div>
                  <span className="uf-bar-percent-right">{r.percent}%</span>
                </div>
              ))}
            </div>

            {/* Top Reported Issues */}
            <div className="uf-card">
              <p className="uf-chart-title">Top Reported Issues</p>
              <hr className="uf-chart-hr" />
              {stats.top_issues.map((issue, idx) => {
                // assign colors in the same order as the static version
                const colors = ['#22c55e', '#3b82f6', '#f59e0b', '#8b5cf6', '#06b6d4', '#64748b'];
                const color  = colors[idx % colors.length];
                return (
                  <div className="uf-bar-row" key={issue.name}>
                    <span className="uf-dot" style={{ background: color }} />
                    <span className="uf-issue-label">{issue.name}</span>
                    <div className="uf-bar-track">
                      <div
                        className="uf-bar-fill"
                        style={{ width: `${(issue.count / maxIssueCount) * 100}%`, background: color }}
                      />
                    </div>
                    <span className="uf-bar-percent-right">{issue.percent}%</span>
                  </div>
                );
              })}
            </div>

          </div>
        )}

        {/* ── Table ── */}
        <div className="uf-table-wrap">

          {/* Filters */}
          <div className="uf-filters-bar">
            {dropdowns.map(d => (
              <div className="uf-select-wrap" key={d.value}>
                <select className="uf-select" value={d.value} onChange={e => d.onChange(e.target.value)}>
                  {d.options.map(o => <option key={o}>{o}</option>)}
                </select>
                <span className="uf-select-chevron"><ChevronDownIcon /></span>
              </div>
            ))}
            <div className="uf-search-wrap">
              <SimpleSearchBox
                placeholder="Search feedback..."
                defaultValue={searchQuery}
                onSearchSelect={(value) => setSearch(value)}
              />
            </div>
          </div>

          <table className="uf-table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Rating</th>
                <th>Issue</th>
                <th>User Name</th>
                <th>Feedback</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {tableLoading ? (
                <tr>
                  <td colSpan={7} className="uf-loading-cell">Loading…</td>
                </tr>
              ) : feedbacks.length === 0 ? (
                <tr>
                  <td colSpan={7} className="uf-empty-cell">No feedback found.</td>
                </tr>
              ) : (
                feedbacks.map((item, idx) => (
                  <tr key={item.id} className={selectedItems.includes(item.id) ? 'selected' : ''}>
                    <td>{item.date}</td>
                    <td>
                      <div className="uf-rating-cell">
                        <span className="uf-dot" style={{ background: RATING_DOT_COLOR[item.rating_label] || '#94a3b8' }} />
                        <span className="uf-rating-label">{item.rating_label}</span>
                      </div>
                    </td>
                    <td>
                      <div className="uf-badges">
                        {item.issues.map(tag => (
                          <span key={tag.id} className={`uf-badge ${issueBadgeClass(tag.name)}`}>{tag.name}</span>
                        ))}
                      </div>
                    </td>
                    <td className="uf-username">{item.user_name}</td>
                    <td>{item.feedback}</td>
                    <td>
                      <span className={`uf-status ${statusClass(item.status)}`}>
                        {/* Capitalize for display: "solved" → "Solved" */}
                        {item.status.charAt(0).toUpperCase() + item.status.slice(1)}
                      </span>
                    </td>
                    <td>
                      <button className="uf-dots-btn"><DotsIcon /></button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {/* Pagination */}
          <div className="uf-pagination">
            <span className="uf-pagination-info">
              {totalCount === 0
                ? 'No results'
                : `Showing ${showingFrom} to ${showingTo} of ${totalCount} results`}
            </span>
            <div className="uf-pagination-controls">
              <button
                className="uf-page-btn"
                disabled={currentPage === 1}
                onClick={() => setPage(p => Math.max(1, p - 1))}
              >
                Previous
              </button>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map(p => (
                <button
                  key={p}
                  className={`uf-page-btn ${currentPage === p ? 'active' : ''}`}
                  onClick={() => setPage(p)}
                >
                  {p}
                </button>
              ))}
              <button
                className="uf-page-btn"
                disabled={currentPage === totalPages}
                onClick={() => setPage(p => Math.min(totalPages, p + 1))}
              >
                Next
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default UserFeedbacks;